import ArtifactElementCard from "./ArtifactElementCard";

export default ArtifactElementCard;
